export default {
  // array of objects
  items: [],
  // array of applied filters
  filters: [],
}
